var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstruction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.32382 0.25C4.32314 0.25 4.32238 0.25 4.32171 0.25C4.08526 0.25 3.86287 0.334452 3.69494 0.487931C3.52516 0.643107 3.43164 0.849725 3.43164 1.06969V13.3607C3.43164 13.8115 3.83341 14.179 4.32735 14.1802C6.40968 14.1847 9.89841 14.5824 12.3052 16.8901V4.02713C12.3052 3.87434 12.2626 3.73081 12.1822 3.61204C10.2068 0.697326 6.41086 0.254473 4.32382 0.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.5678 13.3608V1.06969C22.5678 0.849725 22.4742 0.643107 22.3045 0.487931C22.1365 0.334452 21.914 0.25 21.6778 0.25C21.677 0.25 21.6763 0.25 21.6756 0.25C19.5886 0.25455 15.7927 0.697403 13.8172 3.61212C13.7368 3.73089 13.6943 3.87442 13.6943 4.0272V16.8901C16.1011 14.5824 19.5898 14.1847 21.6721 14.1802C22.166 14.179 22.5678 13.8114 22.5678 13.3608Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.6056 3.08447H23.9569V13.3607C23.9569 14.5115 22.9336 15.4499 21.6757 15.4527C19.9094 15.4566 16.9971 15.773 14.9346 17.5616C18.5018 16.7614 22.2622 17.2816 24.4053 17.7291C24.6729 17.7849 24.9494 17.7272 25.1638 17.5707C25.3775 17.4145 25.5 17.181 25.5 16.9304V3.904C25.5001 3.45213 25.0987 3.08447 24.6056 3.08447Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.0431 13.3607V3.08447H1.39445C0.901348 3.08447 0.5 3.45213 0.5 3.904V16.9302C0.5 17.1809 0.622559 17.4142 0.836196 17.5704C1.05042 17.7269 1.32669 17.7848 1.5947 17.7288C3.73781 17.2813 7.49834 16.7612 11.0654 17.5614C9.00289 15.7729 6.09059 15.4565 4.32434 15.4526C3.06651 15.4499 2.0431 14.5115 2.0431 13.3607Z",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstruction);
export default __webpack_public_path__ + "static/media/icon-instruction.fb5ccdd9e0bc4dea0aeec0ac0a8787a8.svg";
export { ForwardRef as ReactComponent };